// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Anchors__Wrapper_2PuW9","Inner":"Anchors__Inner_3kLvP container grid","Item":"Anchors__Item_1caTE","Link":"Anchors__Link_2MgTP"};